"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactOverlays = require("react-overlays");

var _BaseTheme = _interopRequireDefault(require("../Themes/BaseTheme"));

var _AppIcon = _interopRequireDefault(require("../ImagesAndIcons/AppIcon"));

var _DropdownContainer = _interopRequireDefault(require("../Filters/DropdownContainer"));

var _DropdownToggle = _interopRequireDefault(require("../Filters/DropdownToggle"));

var _GameOptions = _interopRequireDefault(require("../Filters/GameOptions"));

var _BaseButton = _interopRequireDefault(require("../Buttons/BaseButton"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const Nav = _styledComponents.default.nav.withConfig({
  displayName: "GameMenu__Nav",
  componentId: "design-system__uv16n6-0"
})(["box-sizing:border-box;& > *{box-sizing:border-box;}& > ul{display:flex;list-style:none;margin:0;padding:0;}& > ul > li{flex:0 0 auto;color:#fff;transition-duration:0.5s;height:4.5rem;}& > ul > li:hover{background:#f9f9f9;}& hr{border:none;border-right:1px solid ", ";height:2.5rem;margin:18px 1.25rem 0 0.75rem;}"], _BaseTheme.default.colors.lightergray);

const AllGamesLabel = _styledComponents.default.span.withConfig({
  displayName: "GameMenu__AllGamesLabel",
  componentId: "design-system__uv16n6-1"
})(["", ";"], _BaseButton.default);

const GameMenu = _ref => {
  let {
    label,
    slug,
    options: baseOptions,
    allPath,
    allSlug,
    allPathOnClick
  } = _ref;
  const [show, setShow] = (0, _react.useState)(false);
  const options = (0, _react.useMemo)(() => baseOptions.map(opt => _objectSpread(_objectSpread({}, opt), {}, {
    onClick: () => {
      setShow(false);
      if (opt.onClick) opt.onClick(opt);
    }
  })), [baseOptions]);
  return /*#__PURE__*/_react.default.createElement(Nav, {
    role: "navigation"
  }, /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_reactOverlays.Dropdown, {
    show: show,
    onToggle: next => setShow(next),
    itemSelector: "button:not(:disabled)",
    drop: "down"
  }, () => /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_DropdownToggle.default, {
    isOpen: show
  }, slug === allSlug ? /*#__PURE__*/_react.default.createElement(AllGamesLabel, null, label) : /*#__PURE__*/_react.default.createElement(_AppIcon.default, {
    type: slug,
    size: "40"
  })), /*#__PURE__*/_react.default.createElement(_DropdownContainer.default, null, /*#__PURE__*/_react.default.createElement(_GameOptions.default, {
    options: options,
    allPath: allPath,
    allPathOnClick: allPathOnClick
  }))))), /*#__PURE__*/_react.default.createElement("hr", null)));
};

GameMenu.propTypes = {
  label: _propTypes.default.string,
  slug: _propTypes.default.string,
  allSlug: _propTypes.default.string,
  allPath: _propTypes.default.oneOfType([_propTypes.default.any]),
  allPathOnClick: _propTypes.default.func,
  options: _propTypes.default.arrayOf(_propTypes.default.object)
};
GameMenu.defaultProps = {
  slug: 'allGames',
  label: 'All Games',
  allPath: '/',
  allSlug: 'allGames',
  allPathOnClick: undefined,
  options: []
};
var _default = GameMenu;
exports.default = _default;